import {Directive, Input, TemplateRef} from '@angular/core';
import {BaseButtonComponent} from '@aviary/buttons/base/base-button.component';
import {ButtonLabelSize, RectangularButtonContentContext} from '@aviary/buttons/button.types';

@Directive({
  host: {
    // This class identifies a rectangular button that should be rendered as a square because it contains only a single icon.
    '[class.mx-icon-only]': 'renderAsIconOnly || (!customContentTemplate && !beforeLabel && !label && !afterLabel && (!!startIcon !== !!endIcon))'
  }
})
export abstract class RectangularButtonComponent extends BaseButtonComponent implements RectangularButtonContentContext {
  @Input() public startIcon?: string;
  @Input() public startIconClasses?: string;
  @Input() public startIconOutlined: boolean = true;

  @Input() public beforeLabel?: string;
  @Input() public beforeLabelClasses?: string;

  @Input() public label?: string;
  @Input() public labelSize: ButtonLabelSize = 'default';

  @Input() public afterLabel?: string;
  @Input() public afterLabelClasses?: string;

  @Input() public endIcon?: string;
  @Input() public endIconClasses?: string;
  @Input() public endIconOutlined: boolean = true;

  // If defined, this content replaces the standard content while preserving the button itself and its behavior.
  @Input() public customContentTemplate?: TemplateRef<unknown>;

  // Forces the button to render as a square.  Generally useful only when using customContentTemplate.
  @Input() public renderAsIconOnly: boolean = false;

  public get buttonContentContext(): RectangularButtonContentContext {
    return this;
  }
}
